import { Badge, Spin, Typography } from 'antd';
import { CommentOutlined } from '@ant-design/icons';
import React from 'react';
import {
  arrayOf, bool, func, number, shape,
} from 'prop-types';
import I18n from 'i18n-js';
import CommentItem from './CommentItem';

const { Text } = Typography;

const CommentList = ({
  ticketId,
  comments = [],
  loading = false,
  onUpdate = null,
  canSetInternalComment = false,
}) => (
  <div className="ticket-comments-list">
    <Spin spinning={loading}>
      <div className="ticket-comments-list__header">
        <CommentOutlined className="ticket-comments-list__header-icon" />
        <Text strong>
          {I18n.t('ticket_comments.title')}
        </Text>
        <Badge count={comments.length} className="ticket-comments-list__badge" />
      </div>

      <div className="ticket-comments-list__items">
        {comments.map((item) => (
          <CommentItem
            key={item.id}
            {...item}
            ticketId={ticketId}
            onUpdate={onUpdate}
            canSetInternalComment={canSetInternalComment}
          />
        ))}
      </div>
    </Spin>
  </div>
);

CommentList.propTypes = {
  ticketId: number.isRequired,
  comments: arrayOf(shape({})),
  loading: bool,
  onUpdate: func,
  canSetInternalComment: bool,
};

export default CommentList;
